/* CreateOsCatalogComponent.js */

"use strict";
const BaseCreateComponent = require("../../../../lib/actions/components/create/BaseCreateComponent");

class CreateCatalogComponent extends BaseCreateComponent {
    constructor(logger, title, message) {
        super(logger, title || "Create OS Catalog Entry - Please specifiy entry name", message);
    }
}
module.exports = CreateCatalogComponent;
